// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { useEffect } from 'react';
import { useToast } from '../contexts/ToastContext';

/**
 * Legacy Toast Component Wrapper
 * Provides backward compatibility for old Toast API while using new ToastContext
 *
 * OLD API: <Toast show={true} type="success" message="Hello" />
 * This wrapper converts it to: showToast('Hello', 'success')
 *
 * @param {boolean} show - Whether to show the toast (old API)
 * @param {string} type - Toast type: 'success', 'error', 'warning', 'info'
 * @param {string} message - The message to display
 */
export default function ToastLegacy({ show, type = 'success', message }) {
  const { showToast } = useToast();

  useEffect(() => {
    if (show && message) {
      showToast(message, type);
    }
  }, [show, message, type, showToast]);

  // This component doesn't render anything - ToastContext handles rendering
  return null;
}
